import React from "react";
import classNames from "classnames";
import type { FormFieldOption, HandleInputChange } from "./types";

type PillsInputProps = {
    name: string;
    options: Array<FormFieldOption>;
    value?: any;
    multiple?: boolean;
    disabled?: boolean;
    onChange: HandleInputChange;
};

const PillsInput = ({
    name,
    options,
    value,
    multiple = true,
    disabled = false,
    onChange,
}: PillsInputProps) => {
    // Determine selected values list
    const selectedValues = React.useMemo(() => {
        if (multiple) {
            if (Array.isArray(value)) {
                return value;
            }
            if (typeof value === "string") {
                return value.split(",").map((v) => v.trim()).filter(Boolean);
            }
            return [];
        }
        return value !== undefined && value !== null ? [value] : [];
    }, [value, multiple]);

    const handlePillClick = (optValue: any) => {
        if (disabled) return;

        let newValue: any;
        if (multiple) {
            if (selectedValues.includes(optValue)) {
                newValue = selectedValues.filter((val) => val !== optValue);
            } else {
                newValue = [...selectedValues, optValue];
            }
        } else {
            newValue = selectedValues.includes(optValue) ? "" : optValue;
        }

        onChange({ target: { name, value: newValue } } as any, name, newValue);
    };

    return (
        <div className="d-flex flex-wrap gap-2 mt-2">
            {options.map((opt) => {
                const isSelected = selectedValues.includes(opt.value);
                return (
                    <button
                        key={String(opt.value)}
                        type="button"
                        className={classNames("btn btn-sm rounded-pill px-3 py-2 fw-semibold transition-all", {
                            "btn-primary text-white": isSelected,
                            "btn-outline-secondary": !isSelected,
                        })}
                        style={{
                            border: isSelected ? "1px solid #7b2ff7" : "1px solid #cbd5e1",
                            backgroundColor: isSelected ? "#7b2ff7" : "#fff",
                            color: isSelected ? "#fff" : "#334155",
                            cursor: disabled ? "not-allowed" : "pointer",
                            opacity: disabled ? 0.6 : 1,
                        }}
                        disabled={disabled}
                        onClick={() => handlePillClick(opt.value)}
                    >
                        {opt.label}
                    </button>
                );
            })}
        </div>
    );
};

export default PillsInput;
